import instanceQuery from 'graphql/queries/salesLedger/SalesReceiptPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SalesReceiptPostingPreview: EntityType = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default SalesReceiptPostingPreview;
